import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const InvoiceIcon = React.memo(
    ({pathFill = variables['colors-mc-text-primary'], width = 30}) => (
        <svg width={remCss(width)}
             height={remCss(width)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M35 20V29.7675C35 32.6558 32.6558 35 29.7674 35H10.2326C7.34419 35 5 32.6558 5 29.7675V15.814C5 12.9256 7.34419 10.5814 10.2326 10.5814H19.2465C20.0698 10.5814 20.8233 10.9861 21.2837 11.6698L23.2512 14.614C23.3209 14.7117 23.4186 14.7675 23.5442 14.7675H29.7674C32.6558 14.7675 35 17.1117 35 20ZM25.2326 24.1861C25.2326 23.614 24.7581 23.1396 24.186 23.1396H21.0465V20C21.0465 19.4279 20.5721 18.9535 20 18.9535C19.4279 18.9535 18.9535 19.4279 18.9535 20V23.1396H15.814C15.2419 23.1396 14.7674 23.614 14.7674 24.1861C14.7674 24.7582 15.2419 25.2326 15.814 25.2326H18.9535V28.3721C18.9535 28.9442 19.4279 29.4186 20 29.4186C20.5721 29.4186 21.0465 28.9442 21.0465 28.3721V25.2326H24.186C24.7581 25.2326 25.2326 24.7582 25.2326 24.1861Z"
              fill={pathFill}/>
          <path opacity="0.3"
                d="M13.0232 5C10.9999 5 9.33945 6.5907 9.21387 8.58605C9.54875 8.54419 9.88363 8.48837 10.2325 8.48837H19.2464C20.7674 8.48837 22.1767 9.24186 23.0139 10.5116L24.465 12.6744H29.7674C31.1767 12.6744 32.4883 13.093 33.6046 13.7907V8.83721C33.6046 6.71628 31.8883 5 29.7674 5H13.0232Z"
                fill={pathFill}/>
        </svg>

    ),
);
InvoiceIcon.displayName = 'InvoiceIcon';

export default InvoiceIcon;
